import campaignService from '@/modules/common/services/campaignService'

const state = {
  campaignTriggers: [],
  pendingTrigger: null,
  campaignTrigger: null,
  campaign: null
}

const getters = {
  campaignTriggers: (state) => state.campaignTriggers,
  pendingTrigger: (state) => state.pendingTrigger,
  campaignTrigger: (state) => state.campaignTrigger,
  campaign: (state) => state.campaign
}

const mutations = {
  setPendingTrigger(state, pendingTrigger) {
    state.pendingTrigger = pendingTrigger
  },
  setCampaignTriggers(state, triggers) {
    state.campaignTriggers = triggers
  },
  setCampaignTrigger(state, trigger) {
    state.campaignTrigger = trigger;
  },
  setCampaign(state, campaign) {
    state.campaign = campaign;
  }
}

const actions = {
  async loadTriggers({commit}) {
    try {
      const campaignTriggers = await campaignService.getCampaignTriggers()
      commit('setCampaignTriggers', campaignTriggers)
      return campaignTriggers
    } catch (e) {
      console.error('error:', e.error)
    }
  },
  async updateTrigger({state}, payload) {
    const {campaignUid, trigger} = payload;
    if (!campaignUid || !trigger) return;
    const {subject, sms_content} = trigger;

    try {
      await Promise.all([
        campaignService.updateCampaignTrigger(campaignUid, trigger),
        campaignService.saveCampaign({uid: campaignUid, subject, sms_content})
      ]);
    } catch (e) {
      console.error('error:', e.error)
    }
  },
  setPendingTrigger({commit}, trigger) {
    commit('setPendingTrigger', trigger);
  },
  async getTrigger({commit}, campaignUid) {
    if (!campaignUid) return;

    try {
      const res = await Promise.all([campaignService.getCampaignTrigger(campaignUid), campaignService.getCampaign(campaignUid)]);
      const trigger = {subject: res[1].subject, sms_content: res[1].sms_content, ...res[0]};
      commit('setCampaignTrigger', trigger);
    } catch (e) {
      console.error('error:', e.error)
    }
  },
  async saveTrigger({commit}, payload) {
    const {campaignUid, trigger} = payload;
    if (!campaignUid || !trigger) return;
    const {subject, sms_content} = trigger;

    try {
      await Promise.all([
        campaignService.setCampaignTrigger(campaignUid, trigger),
        campaignService.saveCampaign({uid: campaignUid, subject, sms_content})
      ]);
    } catch (e) {
      console.error('error:', e.error)
    }
  },
  async getCampaign({commit}, campaignUid) {
    try {
      const campaign = await campaignService.getCampaign(campaignUid);
      commit('setCampaign', campaign);
    } catch (e) {
      console.error('error:', e.error)
    }
  },
  async saveCampaign({commit}, payload) {
    const {campaignUid, active} = payload;
    if (!campaignUid) return;

    try {
      return await campaignService.saveCampaign({uid: campaignUid, automatic_campaign: {active}});
    } catch (e) {
      console.error('error:', e.error)
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
